var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Area","width":"24","height":"24","fill":"#fcfcfc","opacity":"0","key":0}),React.createElement("g",{"id":"Icon","transform":"translate(1.653 8.999)","key":1},[React.createElement("line",{"id":"Line","x2":"18","transform":"translate(4.347 -2.999) rotate(45)","fill":"none","stroke":"#2b79ff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line-2","data-name":"Line","x2":"18","transform":"translate(4.347 9.731) rotate(-45)","fill":"none","stroke":"#2b79ff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})])]);
}

CloseIcon.defaultProps = {"id":"menu-Icon","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
